import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class CustomerInterceptor implements HttpInterceptor{
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('app_id') && req.url.includes('customers') && req.method == 'GET') {
      const newReq = req.clone({
        params: (req.params ? req.params : new HttpParams())
                   .set('membershipLevel', 'customer') /*.... add new params here .....*/
      });

      return next.handle(newReq);
    }
    return next.handle(req);
  }

}
